import React from 'react';
import ToggleComponent from '../components/common/ToggleComponent';
import SvgIcon from '../components/common/SvgIcon';

class PagePreferencesAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="site-main" className="page page-alerts">
        <div
          className="container"
          id="site-main-container"
          role="main"
          tabIndex="-1"
        >
          <div className="row">
            <div className="col-md1-24">
              <div className="c-step-header">
                <p className="c-step-header__crumbs">
                  <a
                    className="c-step-header__link"
                    href=""
                    onClick={this.props.closed}
                  >
                    <span className="icon icon-page-back c-step-header__linkicon" />
                    <span className="c-step-header__linktext">Back</span>
                  </a>
                </p>
                <h2
                  className="c-step-header__title"
                  id="page-preferences-order-heading"
                >
                  Manage your alerts
                </h2>
              </div>

              <div className="c-account c-account--preferences">
                <h3 className="c-account__name">
                  <a className="c-account__link" href="">
                    Savings
                  </a>
                </h3>

                <dl className="c-account__defs">
                  <dt className="c-account__term">Sortcode</dt>
                  <dd className="c-account__sortno">23-44-61</dd>
                  <dt className="c-account__term">Account number</dt>
                  <dd className="c-account__accountno">413423466</dd>
                  <dt className="c-account__term">Balance</dt>
                  <dd className="c-account__balance">&pound;1,200.50</dd>
                </dl>
              </div>

              <dl
                role="group"
                aria-labelledby="accidentifier1"
                className="c-account-identifier"
              >
                <dt className="c-account-identifier__term">Name</dt>
                <dd id="accidentifier1" className="c-account-identifier__name">
                  Current account
                </dd>
                <dt className="c-account-identifier__term">Sortcode</dt>
                <dd className="c-account-identifier__sortno">23-44-61</dd>
                <dt className="c-account-identifier__term">Account number</dt>
                <dd className="c-account-identifier__accountno">413423466</dd>
                <dt className="c-account-identifier__term">Balance</dt>
                <dd className="c-account-identifier__balance">
                  &pound;1,000,000,000.50
                </dd>
              </dl>

              <fieldset className="c-panel ">
                <h3 className="c-panel__heading">
                  <span className="c-panel__icon icon icon-alerts" /> Take
                  action alerts
                </h3>

                <div className="c-panel__body l-preferences">
                  <div className="l-preferences__account">
                    <p>
                      Send me a <strong>text</strong> if my account gets{' '}
                      <strong>too low to cover payments</strong>, alerting me to{' '}
                      <strong>take action</strong> to avoid or minimise bank
                      charges.
                    </p>

                    <p>
                      <a href="">More</a>
                    </p>
                  </div>

                  <div className="l-preferences__preferences">
                    <ToggleComponent />
                  </div>
                </div>
              </fieldset>

              <div className="c-panel ">
                <div className="c-panel__body l-preferences">
                  <div className="l-preferences__account">
                    <h3>
                      Take action alerts
                      <SvgIcon id="icon-alert" width="32px" height="32px" />
                    </h3>

                    <p>
                      Lorem ipsum dolor{' '}
                      <span className="c-field c-field--inline">
                        {/* <label className="c-field__label c-field__label--block" for="f1">Input</label> */}
                        <span className="c-field__controls">
                          <input
                            className="c-field__input"
                            type="text"
                            name="f1"
                            id="f1"
                          />
                        </span>{' '}
                        set elit nullum vitae.
                      </span>
                    </p>

                    <ToggleComponent />

                    <p>
                      Send a text every{' '}
                      <span className="c-field c-field--inline">
                        <span
                          aria-label="Pick a day of the week"
                          className="c-field__controls"
                        >
                          <select
                            className="c-field__input c-field__input--select"
                            id="d002"
                          >
                            <option selected="" value="def">
                              Monday
                            </option>
                            <option value="one">Tuesday</option>
                            <option value="two">Wednesday</option>
                            <option value="three">Thursday</option>
                          </select>
                        </span>
                      </span>
                    </p>

                    <p>
                      Send me a <strong>text</strong> if my account gets{' '}
                      <strong>too low to cover payments</strong>, alerting me to{' '}
                      <strong>take action</strong> to avoid or minimise bank
                      charges.
                    </p>
                    <p>
                      <a href="">More information</a>
                    </p>
                    <p>
                      Lorem [See <strong>AccountCardComponent.jsx</strong>]
                      ipsum dolor sit amet consectetur adipisicing elit. Quis
                      repellendus commodi temporibus numquam, dicta inventore
                      illo. Cum quidem sit mollitia dolorum eos amet, cupiditate
                      quae reiciendis dicta recusandae eum nostrum optio ab.
                    </p>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Consequatur excepturi voluptas omnis.
                    </p>
                  </div>

                  <div className="l-preferences__preferences">
                    <div className="">
                      <label
                        htmlFor="cb2"
                        className="c-account__controls-middle a-label"
                      >
                        <input
                          className="a-checkbox"
                          id="cb2"
                          name="cb2"
                          defaultChecked
                          type="checkbox"
                        />
                        <span>
                          <span className="u-visually-hidden off-screen">
                            Shown
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <h2>Custom alerts</h2>

              <div className="c-panel">
                <div className="c-panel__body l-preferences">
                  <div className="l-preferences__account">
                    <h3>Weekly balance update</h3>
                    <p>
                      Send me a text every{' '}
                      <select className="a-inline-select">
                        <option>Sunday</option>
                        <option>Monday</option>
                        <option>Tuesday</option>
                        <option>Wednesday</option>
                        <option>Thursday</option>
                        <option>Friday</option>
                        <option>Saturday</option>
                      </select>{' '}
                      dolor set elit.
                    </p>
                  </div>

                  <div className="l-preferences__preferences">
                    <div className="">
                      <label
                        htmlFor="cb3"
                        className="c-account__controls-middle a-label"
                      >
                        <input
                          className="a-checkbox"
                          id="cb3"
                          name="cb3"
                          defaultChecked
                          type="checkbox"
                        />
                        <span>
                          <span className="u-visually-hidden off-screen">
                            Shown
                          </span>
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="form-actions">
                    <a href="" className="c-btn c-btn--secondary">
                      Back
                    </a>
                    <button
                      type="submit"
                      href=""
                      className="c-btn c-btn--default"
                    >
                      Confirm changes
                    </button>
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <a href="" className="c-btn c-btn--secondary">
                  Back
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PagePreferencesAlerts;
